var map = {
	"./1-yournotes-v2.png": 1301,
	"./10-lantern-loft.png": 6375,
	"./2-vue-movies.png": 8855,
	"./3-the-frontend.png": 8893,
	"./4-color-picker.png": 6991,
	"./5-social-proof.png": 7833,
	"./6-loopstudios.png": 5409,
	"./7-blog.png": 298,
	"./8-calculate-it.png": 2946,
	"./9-brain-bender.png": 2486,
	"./team.svg": 7359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7895;